import { Box, Button, createStyles, Modal, Text } from "@mantine/core";
import { LuPlayCircle } from "react-icons/lu";

const useStyles = createStyles(() => ({
  header: {
    display: "flex",
    gap: "14px",
    padding: "22px 26px 14px",
    alignItems: "flex-start",
  },
  iconBox: {
    width: "44px",
    height: "44px",
    minWidth: "44px",
    borderRadius: "10px",
    background: "var(--app-tint-amber)",
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
  },
  headerTitle: {
    margin: 0,
    fontSize: "18px",
    fontWeight: 700,
    color: "var(--app-text)",
    lineHeight: 1.3,
  },
  headerDesc: {
    margin: "4px 0 0",
    fontSize: "13px",
    color: "var(--app-text-muted)",
    lineHeight: 1.5,
  },
  body: {
    padding: "4px 26px 22px",
  },
  footer: {
    padding: "14px 26px 22px",
    borderTop: "1px solid var(--app-border)",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  skipBtn: {
    border: "1px solid var(--app-border)",
    color: "var(--app-text)",
    background: "var(--app-surface)",
    "&:hover": { background: "var(--app-border)" },
  },
  demoBtn: {
    background: "var(--app-primary)",
    color: "var(--app-on-primary)",
    fontWeight: 600,
    "&:hover": { background: "var(--app-primary)", filter: "brightness(0.95)" },
  },
}));

const BillingDemoConfirmModal = ({ opened, onClose, onTakeDemo, onSkip }) => {
  const { classes } = useStyles();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size={480}
      radius="lg"
      zIndex={1000}
      centered
      withCloseButton={false}
      overlayProps={{ blur: 3 }}
      styles={{ body: { padding: 0 } }}
    >
      <Box className={classes.header}>
        <Box className={classes.iconBox}>
          <LuPlayCircle size={22} color="#B7791F" />
        </Box>
        <Box>
          <Text component="h2" className={classes.headerTitle}>
            Want a quick guided demo first?
          </Text>
          <Text className={classes.headerDesc}>
            See how billing setup and claims work end to end, with a
            step-by-step walkthrough — no changes made to your account.
          </Text>
        </Box>
      </Box>

      <Box className={classes.body}>
        <Text size="sm" color="var(--app-text-muted)">
          You can always skip this and go straight to setting up billing with
          your real information.
        </Text>
      </Box>

      <Box className={classes.footer}>
        <Button variant="default" className={classes.skipBtn} onClick={onSkip}>
          Skip, I&apos;ll set it up myself
        </Button>
        <Button className={classes.demoBtn} onClick={onTakeDemo}>
          Take a Demo
        </Button>
      </Box>
    </Modal>
  );
};

export default BillingDemoConfirmModal;
